import { useCallback } from 'react';
import { Modal } from '@client/components/globals/Modal';
import { ShareModal } from './ShareModal';

export const useShareShowCall = (beaconId: string) => useCallback(() => Modal.show({
  title: 'Share',
  body: <ShareModal beaconId={beaconId} />,
  buttons: [],
}), [beaconId]);
